
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calendar/[eventId]",
      function () {
        return require("private-next-pages/calendar/[eventId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calendar/[eventId]"])
      });
    }
  